module.exports = __webpack_public_path__ + "img/photo-0051.71426e46.jpg";